import script from "./NewVersionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewVersionDialog.vue?vue&type=script&setup=true&lang=js"

import "./NewVersionDialog.vue?vue&type=style&index=0&id=a0c3de2a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0c3de2a"]])

export default __exports__